export default "__VITE_ASSET__Cjo4_tyQ__"